<template>
  <div class="about">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <b-card title="Activate TestWatcher" :sub-title="$store.getters.getCardSubtitle" class="mt-4">
            <hr />
            <router-view />
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.about {
  height: 100vh;
  background: url("../assets/engine-ipad-2000x1335-mono.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
</style>

<script>
export default {
  name: "about",
  data() {
    return {
    };
  },
};
</script>